import { api } from './authService';

export interface DashboardData {
  today_agenda: any[];
  tasks_due: any[];
  unread_messages: number;
  recent_lab_results: any[];
  recent_patients: any[];
  kpis: {
    consultations_today: number;
    no_show_rate: number;
    avg_consultation_time: number;
    patient_satisfaction: number;
  };
  telemed_sessions: any[];
  clinical_alerts: any[];
}

class DoctorDashboardService {
  async getDashboardData(date: string): Promise<DashboardData> {
    const response = await api.get(`/doctor/dashboard?date=${date}`);
    return response.data.data;
  }
}

export const doctorDashboardService = new DoctorDashboardService();

